
























































































































import { Component, Mixins } from "vue-property-decorator";
import dateranges from "@/data/dateranges";
import AdminBrandId from "@/mixins/adminBrandId";
import BrandsStore from "@/mixins/brandsStore";
import StatsStorageMixin from "@/mixins/statsStorageMixin";
import { overdueInvoicesQuickFilter } from "@/router/admin/billing/menu";

@Component({
  components: {
    "chart-provider": () =>
      import("@/components/app/global/stats/charts/chart/chartProvider.vue"),
    "stat-header": () => import("@/components/app/global/stats/statHeader.vue"),
    "cash-total": () => import("@/components/app/global/stats/cashTotal.vue"),
    "invoices-category-total-paid": () =>
      import("@/components/app/global/stats/invoicesCategoryTotalPaid.vue"),
    "mrr-stat": () => import("@/components/app/global/stats/mrrStat.vue"),
    "invoices-category-total-overdue-all-time": () =>
      import(
        "@/components/app/global/stats/invoicesCategoryTotalOverdueAllTime.vue"
      ),
    "orders-total": () =>
      import("@/components/app/global/stats/ordersTotal.vue"),
    "clients-total-new": () =>
      import("@/components/app/global/stats/clientsTotalNew.vue"),
    "clients-total-all-time": () =>
      import("@/components/app/global/stats/clientsTotalAllTime.vue"),
    "chart-revenue": () =>
      import("@/components/app/global/stats/charts/revenueChart.vue"),
    "chart-orders": () =>
      import("@/components/app/global/stats/charts/ordersChart.vue"),
    "tickets-active-all-time": () =>
      import("@/components/app/global/stats/ticketsActiveAllTime.vue"),
    "timeline-component": () =>
      import("@/components/app/global/timelineComponent/index.vue"),
    "select-range-and-group-dropdow": () =>
      import(
        "@/components/app/global/stats/charts/selectRangeAndGroupDropdown.vue"
      )
  }
})
export default class Dashboard extends Mixins(
  AdminBrandId,
  StatsStorageMixin,
  BrandsStore
) {
  public range = this.tryGetStatDateFromStorage(dateranges.ranges.last30days);

  public currencyCode = null;

  public dateTimeNow = new Date();

  public overdueInvoicesRoute = overdueInvoicesQuickFilter;
}
